import axios from 'axios';
import { API_URL, API_KEY } from '../lib/constants';

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: { 'x-api-key': API_KEY },
});

const getHeaders = (userId?: string, orgId?: string): Record<string, string> => {
  const headers: Record<string, string> = { 'x-api-key': API_KEY };
  if (userId) headers['x-user-id'] = userId;
  if (orgId)  headers['x-org-id']  = orgId;
  return headers;
};

/**
 * Mark the sample policy wizard as complete for this user.
 * Prevents the "Create Your First Policy" sidebar prompt from appearing again.
 */
export const markWizardComplete = async (
  userId: string,
  orgId: string
): Promise<void> => {
  await api.patch('/api/revisr/sample-policy/complete', {}, {
    headers: getHeaders(userId, orgId),
  });
};
